<template>
  <section class="n-container img-wrap">
    <section class="image-detail__wrap">
      <div class="image-wrap">
        <div
          class="image-preview"
          :style="{ backgroundImage: 'url(' + img + '?x-oss-process=image/resize,w_787,h_442,m_fill)' }"
        >
          <div class="scale-btn__wrap" @click="scaleImage = true">
            <n-icon icon="iconfangdajing1"></n-icon>点击查看大图
          </div>
          <!-- <img :src="img" alt="" /> -->
        </div>
        <div class="image-detail">
          <div class="image-info">
            <ul>
              <li>
                摄影师:<span>{{ imageInfo.author }}</span>
              </li>
              <li>
                图片ID:<span>{{ imageInfo.iamgeId }}</span>
              </li>
              <li>
                体积:<span>{{ imageInfo.size }}</span>
              </li>
              <li>
                尺寸:<span>{{ imageInfo.px }}</span>
              </li>
              <li>
                格式:<span>{{ imageInfo.format }}</span>
              </li>
              <li>
                授权:
                <div class="auth-tab">
                  <a
                    href="javascript:void(0)"
                    class="item"
                    :class="[activeAuthTab == 1 ? 'active' : '']"
                    @click="selAuthTab(1)"
                  >
                    标准授权
                  </a>
                  <a
                    href="javascript:void(0)"
                    class="item"
                    :class="[activeAuthTab == 2 ? 'active' : '']"
                    @click="selAuthTab(2)"
                  >
                    扩展授权
                  </a>
                </div>
                <el-tooltip effect="light" content="授权说明" placement="top">
                  <n-icon icon="iconwenhao-quan--1" fill @click="dialogAuthDesc = true"></n-icon>
                </el-tooltip>
              </li>
            </ul>
          </div>
          <div class="btn-wrap">
            <div
              class="image-licence"
              :class="[downState == 1 ? 'downloaded' : '']"
              @click="handleClick"
            >
              {{ downStateLabels[downState] }}
            </div>
             <n-button type="default" @click="handlePay">购买套餐</n-button>
            <div class="image-buy">

            </div>
          </div>
        </div>
      </div>
      <div class="image-btn__wrap">
        <n-button
          type="secondary"
          @click="handleFavorite"
          :icon="`${imageInfo.favorite_id>=0 ? 'iconshoucang-hong' : 'iconshoucang-hui'}`" :iconFill="imageInfo.favorite_id>=0"
          >收藏</n-button
        >
        <n-button
          type="secondary"
          icon="icongantanhao-quan--"
          @click="reportshow=true"
          >举报</n-button
        >
        <n-button
          type="secondary"
          icon="iconwenhao-quan--1"
          @click="toQA"
          >
            常见问题
          </n-button
        >
      </div>
    </section>
    <section class="setup-wrap">
      <h2>购买流程</h2>
      <div class="setup-body">
        <div class="setup setup-1" :class="setup == 1 ? 'active' : ''">
          <div class="circle"></div>
          <h4>1 <span>套餐购买</span></h4>
          <p>根据需要的图片张数选择套餐<br />完成付款后可在线申请发票</p>
          <p></p>
        </div>
        <n-icon icon="iconshangxiazuoyougengduo" :fill="setup == 1"></n-icon>
        <div class="setup setup-2" :class="setup == 2 ? 'active' : ''">
          <div class="circle"></div>
          <h4>2 <span>下载图片</span></h4>
          <p>可以通过搜索筛选等方式挑选图片<br />然后到图片下载页下载</p>
        </div>
        <n-icon icon="iconshangxiazuoyougengduo" :fill="setup == 2"></n-icon>
        <div class="setup setup-3" :class="setup == 3 ? 'active' : ''">
          <div class="circle"></div>
          <h4>3 <span>下载授权</span></h4>
          <p>图片下载后可设置被授权方<br />设置完成即可在个人中心下载电子授权书</p>
        </div>
      </div>
    </section>
    <section class="other-photo">
      <section class="title">
        <h4>作者其他作品</h4>
        <a>
          <router-link :to="{path: '/home', query: {id: imageInfo.author_id}}" target="_blank">
            <span>查看全部</span>
            <n-icon icon="iconshangxiazuoyougengduo"></n-icon>
          </router-link>
        </a>

      </section>
      <section class="photo-wrap">
        <div
          class="photo-item"
          v-for="(item, index) in photos"
          :key="index"
          :style="{ backgroundImage: 'url(' + item.thumb_url + '?x-oss-process=image/resize,w_313,h_175,m_fill)' }"
          @click="handleClickPhoto(item)"
        ></div>
      </section>
    </section>
    <!-- 下载对话框 -->
    <base-modal :show.sync="showDownload" title="下载" @ok="handleDownload">
      <div class="download-wrap">
        <p v-if="canDownloadTotal">你的当前账户可下载{{canDownloadTotal}}</p>
        <p v-else>你在套餐有效期内已经购买过该图<br />您可以免费下载该图</p>
      </div>
    </base-modal>
    <!-- 收藏夹对话框 -->
    <fav-modal
      :show.sync="showFav"
      :favs.sync="favs"
      @ok="handleConfirmFav"
    ></fav-modal>
    <!-- 举报对话框 -->
    <base-modal :show.sync="reportshow" @ok="handleReport" title="举报">
      <div class="question-wrap">
        <el-form :model="reportForm" label-position="top">
          <el-form-item label="请选择类型" required>
            <el-select v-model="reportForm.content" placeholder="请选择侵权类型">
              <el-option
                v-for="item in reportOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="请补充描述">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="reportForm.remark"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="您的联系方式">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="reportForm.contact"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </base-modal>
    <!-- 购买弹窗 -->
    <base-modal :show.sync="showBuy">
      <p class="down-content__wrap">您的账户目前可下载0张</p>
      <template v-slot:footer>
        <div class="buy-btn__wrap">
          <n-button size="medium" @click="handleBuy">购买套餐</n-button>
          <n-button type="default" size="medium" @click="handleCancel">取消</n-button>
        </div>
      </template>
    </base-modal>
    <!-- 查看大图 -->
      <div class="mask-big" v-show="scaleImage">
      <div class="pic-wraper"><img :src="img" alt="大图" /></div>
      <n-icon icon="iconchacha--1" @click="scaleImage = false"></n-icon>
    </div>
    <!-- 授权弹窗 -->
    <el-dialog class="z-dialog dialog-auth" title="设置授权信息" width="25%" center
      :visible.sync="dialogAuth" :close-on-click-modal="false" :close-on-press-escape="false"
    >
      <div class="main">
        <el-input class="ipt" type="text" placeholder="请输入被授权个人姓名或企业名称" v-model="authName"></el-input>
        <p>温馨提示：下载后授权讲不受版权保护，版权保护生效时间与确认授权时间同步。</p>
        <p class="tips"><i class="el-icon-warning"></i>确认授权信息后将无法更改，请认真核实被授权信息。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAuth = false">取 消</el-button>
        <el-button type="primary" @click="confirmAuth">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 授权说明-->
    <el-dialog class="z-dialog dialog-authDesc" title="授权说明" width="60%" center :visible.sync="dialogAuthDesc">
      <authDesc></authDesc>
    </el-dialog>
  </section>
</template>

<script>
import NIcon from "../components/icon/NIcon.vue";
import authDesc from "@/components/authDesc";
export default {
  components: { 
    NIcon,
    authDesc,
  },
  data() {
    return {
      //下载状态 0 未购买，1 已购买，未授权
      downState: 0,
      downStateLabels: ["无水印下载", "下载成功，去设置授权信息", "已购图，免费下载"],
      //购买弹窗
      showBuy: false,
      // 查看大图
      scaleImage: false,
      //可下载数量
      canDownloadTotal:0,
      img:
        "",
      //下载对话框
      showDownload: false,
      //收藏夹
      favs: [],
      //收藏夹对话
      showFav: false,
      //是否收藏
      isFavorite: false,
      //举报对话框
      reportshow: false,
      //购买流程样式切换
      setup: 2,
      isLogin: false,
      imageInfo: {
        author: "千途摄影师",
        author_id: "",
        iamgeId: "",
        md5: "",
        size: "",
        px: "",
        format: "jpg",
        favorite_id: -1,
      },
      activeAuthTab:1, // 选择授权；1-标准授权，2-扩展授权
      reportForm: {
        //举报类型
        content: "",
        //举报补充
        remark: "",
        //举报人联系电话
        contact: "",
        //图片id
        m_id: this.$route.query.id,
      },
      reportOptions: [
        { value: "侵权问题", label: "侵权问题" },
        { value: "政治政策问题", label: "政治政策问题" },
        { value: "色情暴力问题", label: "色情暴力问题" },
        { value: "其他问题", label: "其他问题" }
      ],
      photos: [],
      dialogAuth: false, //授权弹窗
      authName:'',//授权名称
      dialogAuthDesc:false, //授权说明
    };
  },
  created() {
    var _self = this;
    this.$axios.post('/api/v1/index/detail', {id: this.$route.query.id}).then(res => {
      if (res.status == 200 && res.data.code == 1) {
        var data = res.data.data;
        _self.isLogin = data.is_login;
        _self.img = data.mark_url;
        _self.imageInfo.iamgeId = data.id;
        _self.imageInfo.size = parseInt(data.size / 1024 / 1024 * 100) / 100 + "MB";
        _self.imageInfo.format = data.ext;
        _self.imageInfo.px = data.width + 'px ' + data.height + 'px';
        _self.imageInfo.md5 = data.md5;
        _self.imageInfo.favorite_id = data.favorite_id;
        _self.imageInfo.author = data.user_info.nickname;
        _self.imageInfo.author_id = data.user_info.user_id;
        _self.favs = data.favorites;
        _self.photos = data.photos;
        _self.downState = data.down_state;
        _self.activeAuthTab = data.image_auth;
      } else {
        this.$router.push({ path: "/" });
      }
    }).catch(error => {
      console.log(error);
    });
  },
  methods: {
    //下载或则设置授权
    handleClick() {
      if (this.isLogin) {
        this.canDownloadTotal = this.$store.state.userInfo.combo_num;
        if (this.downState == 0) {
          //未购买
          if(this.canDownloadTotal > 0) {
            this.showDownload = true;
          } else {
            this.showBuy = true;
          }
        } else if (this.downState == 1) {
          //已购买，未授权
          this.dialogAuth = true;
        } else if (this.downState == 2) {
          //已购买，已授权
          this.handleDownload();
        }
      } else {
        passportLogin.login();
      }

    },
    //购买套餐
    handleBuy(){
      this.handlePay()
    },
    handleCancel(){
      this.showBuy = false;
    },
    //购买套餐支付页面
    handlePay() {
      if (this.isLogin) {
        let routeData = this.$router.resolve({
          path: "/vip"
        });
        window.open(routeData.href, "_blank");
      } else {
        passportLogin.login();
      }

    },
    //下载对话框
    handleDownload() {
      var _self = this;
      this.$axios.post('/api/alioss/down', {id: this.$route.query.id, 'auth': this.activeAuthTab}).then(res => {
        if (res.status == 200 && res.data.code == 1) {
          let a = document.createElement('a');
          a.href = res.data.data.url;
          a.click();
          _self.downState = res.data.data.state;
          _self.$store.state.userInfo.combo_num = res.data.data.combo_num;
          if (_self.downState == 1) {
            this.dialogAuth = true;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    //收藏click
    handleFavorite() {
      if (this.isLogin) {
        if (this.imageInfo.favorite_id >= 0) {
          this.$confirm("是否取消收藏?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            var _self = this;
            this.$axios.api.favoritesCancel({thumb_id: this.$route.query.id}, function (res) {
              if (res.code == 1) {
                _self.$message.success("取消收藏成功！");
                _self.imageInfo.favorite_id = -1;
              } else {
                _self.$message.error("取消收藏失败！");
              }
            });
          }).catch(() => {

          });
        } else {
          this.showFav = true;
        }
      } else {
        passportLogin.login();
      }
    },
    //收藏
    handleConfirmFav(item) {
      if (!item) {
        this.$message.error("请选择收藏夹");
        return;
      }
      var _self = this;
      this.$axios.api.favoritesJoin({favorite_id: item.id, thumb_id: this.$route.query.id}, function (res) {
        if (res.code == 1) {
          _self.$message.success("添加收藏成功！");
          _self.showFav = false;
          _self.imageInfo.favorite_id = res.data.favorite_id;
        } else {
          _self.$message.error("添加收藏失败！");
        }
      });
    },
    //举报
    handleReport() {
      var _self = this;
      if (this.reportForm.content == '') {
        this.$message.error("请选择类型");
        this.reportshow = true;
        return;
      }
      this.$axios.api.report(this.reportForm, function (res) {
        if (res.code == 1) {
          _self.$message.success("提交成功，谢谢！");
          _self.reportForm.content = "";
          _self.reportForm.remark = "";
          _self.reportForm.contact = "";
        } else {
          _self.$message.error("提交失败，请重新尝试！");
          _self.reportshow = true;
        }
      });
    },
    //常见问题
    handleQuestion() {},
    //作者其他作品
    handleClickPhoto(item) {
      let routeData = this.$router.resolve({
        name: "image",
        query: { id: item.id },
      });
      window.open(routeData.href, "_blank");
    },
    //确认授权信息
    confirmAuth(){
      if (!this.authName) {
        this.$message.error("授权名称不能为空");
      }
      var _self = this;
      this.$axios.api.userGrant({name: this.authName}, function (res) {
        if (res.code == 1) {
          _self.$message.success("提交成功，谢谢！");
          _self.downState = 2;
        } else {
          _self.$message.error("提交失败，请重新尝试！");
        }
        _self.dialogAuth = false;
      });
    },
    toQA(){
      let toRoute = this.$router.resolve({path: '/QA'})
      window.open(toRoute.href, '_blank')
    },
    selAuthTab(index){
      this.activeAuthTab = index;
    }
  },
};
</script>

<style lang="scss">
.n-container {
  margin-top: 134px;
}
.img-wrap {
  .image-detail__wrap {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
  }
  .image-wrap {
    display: flex;
  }
  .image-preview {
    width: 787px;
    height: 442px;
    margin-right: 28px;
    position: relative;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    .scale-btn__wrap {
      position: absolute;
      width: 260px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(255, 255, 255, 0.8);
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      bottom: 20px;
      left: 50%;
      cursor: pointer;
      user-select: none;
      transform: translate(-50%, 0%);
      &:hover {
        color: #f77e5e;
      }
    }
  }
  .image-detail {
    display: flex;
    flex-direction: column;
  }
  .image-info {
    width: 508px;
    height: 352px;
    background-color: #ededed;
    margin-bottom: 28px;
    padding: 21px 26px;
    border-radius: 6px;
    > ul {
      width: 100%;
      line-height: 30px;
      font-size: 22px;
      line-height: 30px;
      color: #666666;
      li {
        display: flex;
        align-items: center;
        margin-bottom: 26px;
        > span {
          margin-left: 20px;
          margin-right: 40px;
        }
      }
    }
  }
  .image-btn__wrap,
  .btn-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .image-btn__wrap {
    width: 100%;
    margin-top: 14px;
    padding-left: 100px;
  }
  .image-licence {
    text-align: center;
    width: 342px;
    height: 52px;
    line-height: 52px;
    background-color: $primaryColor;
    margin-right: 16px;
    border-radius: 4px;
    font-size: 24px;
    color: #fff;
    cursor: pointer;
  }
  .image-buy {
    float: left;
    .n-button {
      line-height: 52px;
      padding: 0 16px;
    }
  }
  .setup-wrap {
    text-align: center;
    margin-bottom: 64px;
    h2 {
      font-size: 28px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 10px;
    }
    .setup-body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .setup {
      padding: 8px 60px;
      border: 1px solid #666666;
      // width: 200px;
      margin: 0 10px;
      border-top-right-radius: 12px;
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 20px;
      position: relative;
      font-size: 46px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #666666;
      h4 {
        span {
          font-size: 22px;
        }
      }
      p {
        font-size: 18px;
      }
      .circle {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid #666666;
        position: absolute;
        top: 8px;
        left: 34px;
      }
      &.active {
        border: 1px solid $primaryColor;
        color: $primaryColor;
      }
      &.active .circle {
        border: 1px solid $primaryColor !important;
      }
    }
    .setup-1 {
      border-top-left-radius: 48px;
    }
    .setup-2 {
      border-top-left-radius: 20px;
    }
    .setup-3 {
      border-top-left-radius: 20px;
      border-bottom-right-radius: 48px;
    }
  }
  .other-photo {
    font-size: 22px;
    font-weight: 400;
    color: #333333;
    margin-bottom: 30px;
    .title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
      a {
        cursor: pointer;
        display: flex;
        &:hover {
          color: $primaryColor;
          transition: all 0.2s ease;
        }
        span {
          margin-right: 10px;
        }
      }
    }
    .photo-wrap {
      display: flex;
    }
    .photo-item {
      background-color: #666666;
      width: 313px;
      margin-right: 24px;
      height: 175px;
      background-repeat: no-repeat;
      background-size: cover;
      cursor: pointer;
    }
  }
  .download-wrap {
    padding-top: 40px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 400;
    color: #333333;
  }
  .downloaded {
    background-color: #f01740;
  }
  .question-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 24px;
    .el-form {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
    .el-textarea__inner:focus {
      outline: 0;
      border-color: $primaryColor;
    }
    .el-select .el-input__inner:focus {
      border-color: $primaryColor;
    }
  }
   .mask-big {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    .pic-wraper {
      width: 900px;
      height: 800px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      > img {
        position: relative;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        max-width: 100%;
        max-height: 100%;
        border: 4px solid #fff;
        margin-bottom: 40px;
      }
    }

    .n-icon {
      color: #fff;
      position: absolute;
      bottom: 10px;
      left: 50%;
    }
  }


  .down-content__wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 30px;
    font-size: 18px;
    font-weight: 400;
    color: #333333;
  }
  .buy-btn__wrap {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    .n-button {
      margin-right: 30px;
      margin-left: 30px;
    }
  }
}
.dialog-auth{
  .main{
    margin-top: 15px;
    .ipt{
      margin-bottom: 15px;
    }
    p{
      margin:10px 0;
    }
    .tips{
      color: #f56c6c;
      i{
        margin-right: 5px;
      }
    }
  }
}
.auth-tab{
  height: 36px;
  border-radius: 18px;
  overflow: hidden;
  margin:0 15px;
  .item{
    display: inline-block;
    text-align: center;
    padding: 0 20px;
    color: #9f9f9f;
    font-size:16px;
    height:100%;
    margin:0;
    line-height:36px;
    color: #777;
    background-color: #fff;
    vertical-align: middle;
  }
  .item.active,.item:hover{
    background-color: #ec7a5d;
    color: #fff;
  }
}
</style>
